import Vector from "./vector";
export class FixedSizeVector extends Vector {
}
//# sourceMappingURL=fixedSizeVector.js.map